import React from 'react';
import CONSTANTS from '../../../assets/constants';
import modelInstructions from '../../../assets/Images/modelInstructions.png';

const ModelInstructions = () => (
  <div className="primary-background">
    <div className="grid-container width-100 padding-top-3 padding-bottom-2 padding-horizontal-2">
      <div className="grid-x grid-padding-x">
        <div className="cell small-12 medium-5">
          <img
            className="primary-background white-color instructions-image"
            src={modelInstructions}
            alt="Model Instructions"
          />
        </div>
        <div className="cell small-12 medium-7 padding-left-2">
          <h2 className="padding-bottom-2 white-color">
            {CONSTANTS.HOW_THIS_MODEL_WORKS}
          </h2>
          <p className="padding-bottom-2 white-color">
            {CONSTANTS.HOW_THIS_MODEL_WORKS_TEXT1}
          </p>
          <p className="padding-bottom-2 white-color">
            {CONSTANTS.HOW_THIS_MODEL_WORKS_TEXT2}
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default ModelInstructions;
